import { useCallback, useEffect, useState } from "react";
import { batchApi } from "../../api/batchApi";
import { toBatchListResponse } from "../../pages/batches/batchAdapters";

export const loadAnalyticsBatches = async (plantId) => {
  const rows = [];
  let page = 1;
  while (true) {
    const result = toBatchListResponse(await batchApi.list({ page, limit: 200, ...(plantId ? { plant_id: plantId } : {}) }));
    rows.push(...result.rows);
    if (!result.rows.length || rows.length >= result.total) return rows;
    page += 1;
  }
};

export default function useAnalyticsBatches(plantId) {
  const [state, setState] = useState({ rows: [], plantId, isLoading: true, error: null });
  const [version, setVersion] = useState(0);
  const refetch = useCallback(() => setVersion((current) => current + 1), []);
  useEffect(() => {
    let active = true;
    let timer;
    const load = async () => {
      try {
        const rows = await loadAnalyticsBatches(plantId);
        if (active) setState({ rows, plantId, isLoading: false, error: null });
      } catch (error) {
        if (active) setState((current) => ({ rows: current.plantId === plantId ? current.rows : [], plantId, isLoading: false, error }));
      } finally {
        if (active) timer = window.setTimeout(load, 15000);
      }
    };
    load();
    return () => { active = false; window.clearTimeout(timer); };
  }, [plantId, version]);

  return state.plantId === plantId ? { ...state, refetch } : { rows: [], isLoading: true, error: null, refetch };
}
